import Content from "./content";
import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

export default class HotelDesc extends Content {
	_build() {
		this._dom.container.classList.add("content-hoteldesc");
		this._dom.container.addEventListener("MSAnimationStart", this, false);
		this._dom.container.addEventListener("animationstart", this, false);
		this._dom.bookDesc = node("p", { className: "desc", textContent: this._data });
		this._dom.container.appendChild(this._dom.bookDesc);
	}

	handleEvent(event) {
		if (event.type === "click") {
			this._dom.container.classList.toggle("opened");
			this._dom.bookDesc.classList.toggle("trim");
		} else {
			this._onDOMInserted();
		}
	}

	_onDOMInserted() {
		if (this._dom.bookDesc.clientHeight > 100) {
			const spanHolder = node("span", { className: "more-holder" });
			const moreDesc = node("span", { className: "more-desc", textContent: _("detail.content.booking.moreDesc") });

			this._dom.bookDesc.classList.add("trim");
			moreDesc.appendChild(icon("dropdown"));
			moreDesc.appendChild(icon("dropup"));
			moreDesc.addEventListener("click", this, false);
			this._dom.bookDesc.appendChild(spanHolder);
			this._dom.container.appendChild(moreDesc);
		}

		this._dom.container.removeEventListener("MSAnimationStart", this, false);
		this._dom.container.removeEventListener("animationstart", this, false);
	}
}
